/**
 * Rule condition shapes. The API persists `conditions` as JSONB; the worker validates
 * a flat map of field paths → comparison dict or scalar. Keep types loose enough for
 * future boolean trees / AI-generated plans without breaking today’s payloads.
 */

export const RULE_COMPARISON_OPS = [">", "<", ">=", "<=", "=", "==", "!="] as const;

export type RuleComparisonOp = (typeof RULE_COMPARISON_OPS)[number];

/** One field path → comparisons (multiple ops) or a scalar (legacy / shorthand). */
export type RuleFieldCondition =
  | Partial<Record<RuleComparisonOp, number | string | boolean>>
  | number
  | string
  | boolean;

/** v1: matches `AlertRuleService._validate_conditions` today. */
export type RuleConditionsV1 = Record<string, RuleFieldCondition>;

/**
 * Versioned envelope so AI / advanced builders can add `expression`, `metadata`, etc.
 * Only {@link RuleConditionsV1} is sent to `POST /alerts/rules` until the backend accepts more.
 */
export type RuleExpressionDraft = {
  version: 1;
  conditions: RuleConditionsV1;
  /** Reserved: prompt id, model, explanation — not sent to API yet. */
  metadata?: Record<string, unknown>;
};
